import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        report: '=',
        company: '=',
        language: '='
    },
    template: `
        <div class="report01">
            <div class="report-data01">
                <p class="title01" ng-if="vm.report.isEvaluableReport">{{ vm.report.title }}</p>
                <p class="meta">{{ vm.MomentService.formatDate(vm.report.deadline, 'DD.MM.YYYY', 'DD. MMMM YYYY') }}</p>
            </div>
            <div class="report-title01">
                <p class="small" ng-if="vm.company">{{ vm.getTitle() }}</p>
                <h1>{{ 'report.360° Feedback' | translate }}</h1>
                <p>{{ 'report.Survey' | translate }}</p>
            </div>
            <div class="report-footer01">
                <img
                    ng-if="vm.company.logoFilename"
                    ng-src="{{ vm.CompanyService.getLogoImage(vm.company.logoFilename, vm.company.id, 'evaluationPrintLogo') }}"
                >
            </div>
        </div>
    `
})
export default class {
    constructor (lodash, MomentService, CompanyService, COMPANY_LANGUAGE_ENUM) {
        this.lodash = lodash;
        this.MomentService = MomentService;
        this.CompanyService = CompanyService;
        this.COMPANY_LANGUAGE_ENUM = COMPANY_LANGUAGE_ENUM;
    }

    $onInit () {
        if (!this.language) {
            this.language = this.COMPANY_LANGUAGE_ENUM.KEYS.ET;
        }
    }

    getTitle () {
        let title = '';
        const companyI18n = this.lodash.find(this.company.companyI18ns, (i18n) => {
            return this.language.toUpperCase() === i18n.language;
        });

        if (companyI18n && typeof companyI18n.feedbackReportPrintTitle !== 'undefined') {
            title = companyI18n.feedbackReportPrintTitle;
        }
        return title;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/evaluation/public/report/title/index.js